import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/logos/hc.svg",
    class: "h-65px"
  })
], -1)
const _hoisted_4 = { class: "d-flex flex-center flex-column pt-0" }
const _hoisted_5 = { class: "mb-3 fs-8 text-gray-500" }
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = { class: "d-flex align-items-center fw-bold fs-7 gap-2" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column-auto p-10\"><div class=\"d-flex align-items-center fw-bold fs-6\"><span class=\"text-muted fw-bold me-1\">2022©</span><a href=\"https://hackingclub.io/\" target=\"_blank\" class=\"text-gray-800 text-hover-primary\">Hacking Club </a><a href=\"https://crowsec.com.br/\" target=\"_blank\" class=\"text-gray-300 text-primary\"> powered by Crowsec</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.language`)) + ": ", 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.lang`)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en'))),
          class: "text-gray-700 cursor-pointer text-hover-primary"
        }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.en`)), 1),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('pt'))),
          class: "text-gray-700 cursor-pointer text-hover-primary"
        }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.pt`)), 1),
        _createElementVNode("span", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('es'))),
          class: "text-gray-700 cursor-pointer text-hover-primary"
        }, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.language.es`)), 1)
      ])
    ]),
    _hoisted_8
  ]))
}